//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { onMounted, defineComponent, useContext, useRoute, useRouter } from "@nuxtjs/composition-api";
import { onSSR, useVSFContext } from "@vue-storefront/core";
import {
  useAppState,
  useBloomreach,
  useUserAccount,
} from "~/composables";
import AppShell from "~/components/AppShell.vue";
import { COOKIES } from "~/helpers/constants";
import { checkCMSFlag } from '~/helpers/globalLabels';

export default defineComponent({
  name: "DefaultLayout",
  components: { AppShell },
  setup() {
  const { isLogout, loadInitialAppState } = useAppState();
  const { getAccountInfo, isAuthenticated } = useUserAccount('user-account-info');
  const { initialize: initializeBloomreach, content, configuration, componentsMapping } = useBloomreach();
  const { app: { $cookies }, localePath } = useVSFContext();
  const { i18n } = useContext();
  const router = useRouter();
  const route = useRoute();

  const selectedLocale = i18n.localeProperties.code;

  const setFallbackCountry = () => {
    let countryCode = $cookies.get(COOKIES.MCRCCODE) || "dk";
    let country = $cookies.get(COOKIES.MCRCNTRY) || "Denmark";

    Object.assign(i18n.localeProperties, {
      countryCode,
      baseStoreCode: countryCode,
      country,
      baseCountry: country,
      label: country,
    });
  };

  const checkAndSetCookie = () => {
    const cookiesToCheck = {
      [COOKIES.LOCALE]: selectedLocale,
      [COOKIES.CURRENCY]: i18n.numberFormats[selectedLocale]?.currency?.currency,
      [COOKIES.COUNTRY]: i18n.localeProperties.countryCode,
    };

    for (const [cookieKey, selectedValue] of Object.entries(cookiesToCheck)) {
      const cookieValue = $cookies.get(cookieKey);
      if (selectedValue && selectedValue !== cookieValue) {
        $cookies.set(cookieKey, selectedValue);
      }
    }
  };

  const handleSSR = async () => {
    checkAndSetCookie();
    await initializeBloomreach();
  };

  const handleMounted = async () => {
    if (checkCMSFlag('simplified-header-flag', 'true') && route.value.path === `${localePath(i18n.t('PAGES.MOOMIN_DAY_2024'))}/`) {
      router.push(localePath('/'));
    }

    checkAndSetCookie();
    displayConsoleArt();

    if (!isLogout.value) await loadInitialAppState();
    if (isAuthenticated) await getAccountInfo();
  };

  const displayConsoleArt = () => {
    console.log(
        "\r\n     \r\n                                           >>>>\r\n                                          >>  >>         >>>>>>\r\n                                        >>>   >>>       >>>  >>>\r\n                                        >>>    >>      >>>   >>>\r\n                                        >>     >>>>>>>>>     >>>\r\n                                        >>                   >>>\r\n                                       >>>                   >>>\r\n                                     >>>                     >>>\r\n                                    >>>                       >>>\r\n                                  >>>                         >>>\r\n                                >>>                            >>\r\n                               >>>                             >>>\r\n                             >>>                               >>>\r\n                           >>>                                  >>>\r\n                       >>>>>                                    >>>\r\n                 >>>>>                                          >>>\r\n              >>>                                                >>\r\n            >>>                                                  >>>\r\n            >>>                                                  >>>\r\n            >>                                                   >>>\r\n            >>>                                       >>>>        >>\r\n             >>>                                    >>>           >>>\r\n              >>>                                >>>>             >>>\r\n                >>>                           >>>>                >>>\r\n                  >>>>>                  >>>>>                     >>>\r\n                       >>>>>>>>>>>>>>>>>                           >>>\r\n                               >>>                                  >>>\r\n                              >>>                                    >>>\r\n                             >>>                                      >>>\r\n                            >>>                                        >>>\r\n                           >>>                                          >>\r\n                          >>>                                           >>>\r\n                         >>>                                             >>>\r\n                        >>>                                               >>\r\n     \r\n    "
      );
      console.log(
        "\r\n __          __  _                            _          __  __                       _       \r\n \\ \\        / / | |                          | |        |  \\/  |                     (_)      \r\n  \\ \\  /\\  / /__| | ___ ___  _ __ ___   ___  | |_ ___   | \\  / | ___   ___  _ __ ___  _ _ __  \r\n   \\ \\/  \\/ / _ \\ |/ __/ _ \\| '_ ` _ \\ / _ \\ | __/ _ \\  | |\\/| |/ _ \\ / _ \\| '_ ` _ \\| | '_ \\ \r\n    \\  /\\  /  __/ | (_| (_) | | | | | |  __/ | || (_) | | |  | | (_) | (_) | | | | | | | | | |\r\n     \\/  \\/ \\___|_|\\___\\___/|_| |_| |_|\\___|  \\__\\___/  |_|  |_|\\___/ \\___/|_| |_| |_|_|_| |_|\r\n                                                                                              \r\n                                                                                              \r\n"
      );
  };

  if (selectedLocale === "int") setFallbackCountry();

  onSSR(handleSSR);
  onMounted(handleMounted);

  return {
    content,
    configuration,
    componentsMapping,
  };
},
  head() {
    return this.$nuxtI18nHead({ addSeoAttributes: true });
  },
});
